/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { memo, useEffect, useLayoutEffect } from "react";

const useEnhancedEffect =
  typeof window === "undefined" ? useEffect : useLayoutEffect;

function BASETheme(props) {
  const { direction, theme } = props;
  const { mode } = theme.palette;

  useEnhancedEffect(() => {
    document.body.dir = direction;
  }, [direction]);

  useEffect(() => {
    document.body.classList.add(mode === "light" ? "light" : "dark");
    document.body.classList.remove(mode === "light" ? "dark" : "light");
  }, [mode]);

  // console.warn('BASETheme:: rendered',mainTheme);
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
}

export default memo(BASETheme);
